/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/DocumentDataExtractorTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { DocumentDetectionResult } from '../document_scanner/DocumentScannerTypes';
import { ResultAccumulationConfiguration } from '../frame_accumulation/FrameAccumulationTypes';
import { GenericDocument } from '../generic_document/GenericDocument';
import { ImageRef } from '../image/image';
import { DocumentDataExtractorCommonConfiguration, DocumentDataExtractorConfigurationElement, } from './DocumentDataExtractorConfigurationTypes';
/** @hidden */
export const DocumentDataExtractionStatusValues = [
    'OK',
    'OK_BUT_INVALID_DOCUMENT',
    'OK_BUT_NOT_CONFIRMED',
    'SCANNING_IN_PROGRESS_STILL_FOCUSING',
    'ERROR_NOTHING_FOUND',
    'ERROR_BAD_CROP',
    'ERROR_UNKNOWN_DOCUMENT',
    'ERROR_UNACCEPTABLE_DOCUMENT',
];
/**
Contains the result of running the document data extractor.
*/
export class DocumentDataExtractionResult {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractionResult>`} */
    constructor(source = {}) {
        /**
          Crop of the document if it was detected.
          */
        this.croppedImage = null;
        this._released = false;
        if (source.status !== undefined) {
            this.status = source.status;
        }
        else {
            throw new Error('status must be present in constructor argument');
        }
        if (source.document !== undefined) {
            this.document = source.document != null ? new GenericDocument(source.document) : null;
        }
        else {
            throw new Error('document must be present in constructor argument');
        }
        if (source.documentDetectionResult !== undefined) {
            this.documentDetectionResult = new DocumentDetectionResult(source.documentDetectionResult);
        }
        else {
            throw new Error('documentDetectionResult must be present in constructor argument');
        }
        if (source.croppedImage !== undefined) {
            this.croppedImage = source.croppedImage != null ? ImageRef.from(source.croppedImage) : null;
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            status: this.status,
            document: this.document != null ? await this.document.serialize(config) : null,
            documentDetectionResult: this.documentDetectionResult.serialize(config),
            croppedImage: config.serializeImages
                ? this.croppedImage != null
                    ? await this.croppedImage.serialize(config.imageSerializationMode)
                    : null
                : undefined,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.document != null) {
                this.document.release();
            }
        }
        {
            if (this.croppedImage != null) {
                this.croppedImage.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.document != null) {
            await this.document.encodeImages();
        }
        if (this.croppedImage != null) {
            await this.croppedImage.encodeInPlace();
        }
    }
}
/** @hidden */
export const DocumentTrustModeValues = ['TRUSTED', 'UNTRUSTED'];
/**
Configuration for the document data extractor.
*/
export class DocumentDataExtractorConfiguration {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorConfiguration>`} */
    constructor(source = {}) {
        /**
          Configuration for how to accumulate results.
          */
        this.resultAccumulationConfig = new ResultAccumulationConfiguration({});
        /**
          Normalized names of the fields to exclude from the result.
          */
        this.fieldExcludeList = [];
        /**
          List of configuration elements for the document data extractor.
          */
        this.configurations = [
            new DocumentDataExtractorCommonConfiguration({}),
        ];
        /**
          If true, crops of the detected documents and fields will be returned in the result.
          
          Default is false
          */
        this.returnCrops = false;
        /**
          Level of trust in the authenticity of the extracted document.
          
          Default is TRUSTED
          */
        this.documentTrustMode = 'TRUSTED';
        /**
          Scanners typically can produce better results from a single image if they are allowed to spend a longer time analyzing it.
          
          On the other hand, scanners can produce even better results if they can analyze multiple images of the same subject and cross-check and combine the results.
          The processing mode tells the scanner whether to optimize for single or multiple images of a subject.
          
          Default is AUTO
          */
        this.processingMode = 'AUTO';
        if (source.resultAccumulationConfig !== undefined) {
            this.resultAccumulationConfig = new ResultAccumulationConfiguration(source.resultAccumulationConfig);
        }
        if (source.fieldExcludeList !== undefined) {
            this.fieldExcludeList = source.fieldExcludeList.map((it) => {
                return it;
            });
        }
        if (source.configurations !== undefined) {
            this.configurations = source.configurations.map((it) => {
                return DocumentDataExtractorConfigurationElement.from(it);
            });
        }
        if (source.returnCrops !== undefined) {
            this.returnCrops = source.returnCrops;
        }
        if (source.documentTrustMode !== undefined) {
            this.documentTrustMode = source.documentTrustMode;
        }
        if (source.processingMode !== undefined) {
            this.processingMode = source.processingMode;
        }
    }
}
/** @hidden */
export const ValueConsistencyValues = [
    'OK',
    'OK_PUNCTUATION_UPPER_CASE_CLEANED',
    'OK_DEBURRED',
    'OK_DEBURRED_EXTENDED',
    'OK_TRUNCATED',
    'INCONSISTENT',
];
/**
Report of the field consistency verification.
*/
export class FieldConsistencyVerificationReport {
    /** @param source {@displayType `DeepPartial<FieldConsistencyVerificationReport>`} */
    constructor(source = {}) {
        if (source.fieldType !== undefined) {
            this.fieldType = source.fieldType;
        }
        else {
            throw new Error('fieldType must be present in constructor argument');
        }
        if (source.consistency !== undefined) {
            this.consistency = source.consistency;
        }
        else {
            throw new Error('consistency must be present in constructor argument');
        }
        if (source.fieldFullNames !== undefined) {
            this.fieldFullNames = source.fieldFullNames.map((it) => {
                return it;
            });
        }
        else {
            throw new Error('fieldFullNames must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            fieldType: this.fieldType,
            consistency: this.consistency,
            fieldFullNames: this.fieldFullNames.map((it) => {
                return it;
            }),
        };
    }
}
/**
Report of the document consistency verification. Shows whether information in the fields that correspond to the same logical field is consistent.
*/
export class ConsistencyVerificationReport {
    /** @param source {@displayType `DeepPartial<ConsistencyVerificationReport>`} */
    constructor(source = {}) {
        if (source.overallConsistency !== undefined) {
            this.overallConsistency = source.overallConsistency;
        }
        else {
            throw new Error('overallConsistency must be present in constructor argument');
        }
        if (source.fieldDetails !== undefined) {
            this.fieldDetails = source.fieldDetails.map((it) => {
                return new FieldConsistencyVerificationReport(it);
            });
        }
        else {
            throw new Error('fieldDetails must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            overallConsistency: this.overallConsistency,
            fieldDetails: this.fieldDetails.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/** @hidden */
export const ValueSemanticsValues = ['SKIPPED', 'VALID', 'INVALID'];
/**
Report of the field value semantics verification.
*/
export class FieldValueSemantics {
    /** @param source {@displayType `DeepPartial<FieldValueSemantics>`} */
    constructor(source = {}) {
        if (source.fieldFullName !== undefined) {
            this.fieldFullName = source.fieldFullName;
        }
        else {
            throw new Error('fieldFullName must be present in constructor argument');
        }
        if (source.invalidSemantics !== undefined) {
            this.invalidSemantics = source.invalidSemantics;
        }
        else {
            throw new Error('invalidSemantics must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            fieldFullName: this.fieldFullName,
            invalidSemantics: this.invalidSemantics,
        };
    }
}
/**
Report of a logical field value semantics verification. If some logical field, e.g. expiry date is present in multiple places in the document, it can occur that some entries are semantically correct and some are semantically incorrect. This report shows the overall status of the logical field value semantics verification and details for each field that was verified.
*/
export class CompositeFieldValueSemantics {
    /** @param source {@displayType `DeepPartial<CompositeFieldValueSemantics>`} */
    constructor(source = {}) {
        if (source.overallFieldValueSemantics !== undefined) {
            this.overallFieldValueSemantics = source.overallFieldValueSemantics;
        }
        else {
            throw new Error('overallFieldValueSemantics must be present in constructor argument');
        }
        if (source.fieldDetails !== undefined) {
            this.fieldDetails = source.fieldDetails.map((it) => {
                return new FieldValueSemantics(it);
            });
        }
        else {
            throw new Error('fieldDetails must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            overallFieldValueSemantics: this.overallFieldValueSemantics,
            fieldDetails: this.fieldDetails.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/**
Report of the document value semantics verification.
*/
export class SemanticsVerificationReport {
    /** @param source {@displayType `DeepPartial<SemanticsVerificationReport>`} */
    constructor(source = {}) {
        if (source.overallInvalidSemantics !== undefined) {
            this.overallInvalidSemantics = source.overallInvalidSemantics;
        }
        else {
            throw new Error('overallInvalidSemantics must be present in constructor argument');
        }
        if (source.expiryDateSemantics !== undefined) {
            this.expiryDateSemantics = new CompositeFieldValueSemantics(source.expiryDateSemantics);
        }
        else {
            throw new Error('expiryDateSemantics must be present in constructor argument');
        }
        if (source.issueDateSemantics !== undefined) {
            this.issueDateSemantics = new CompositeFieldValueSemantics(source.issueDateSemantics);
        }
        else {
            throw new Error('issueDateSemantics must be present in constructor argument');
        }
        if (source.birthDateSemantics !== undefined) {
            this.birthDateSemantics = new CompositeFieldValueSemantics(source.birthDateSemantics);
        }
        else {
            throw new Error('birthDateSemantics must be present in constructor argument');
        }
        if (source.issueDateBeforeExpiryDate !== undefined) {
            this.issueDateBeforeExpiryDate = source.issueDateBeforeExpiryDate;
        }
        else {
            throw new Error('issueDateBeforeExpiryDate must be present in constructor argument');
        }
        if (source.birthDateBeforeIssueDate !== undefined) {
            this.birthDateBeforeIssueDate = source.birthDateBeforeIssueDate;
        }
        else {
            throw new Error('birthDateBeforeIssueDate must be present in constructor argument');
        }
        if (source.birthDateBeforeExpiryDate !== undefined) {
            this.birthDateBeforeExpiryDate = source.birthDateBeforeExpiryDate;
        }
        else {
            throw new Error('birthDateBeforeExpiryDate must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            overallInvalidSemantics: this.overallInvalidSemantics,
            expiryDateSemantics: this.expiryDateSemantics.serialize(config),
            issueDateSemantics: this.issueDateSemantics.serialize(config),
            birthDateSemantics: this.birthDateSemantics.serialize(config),
            issueDateBeforeExpiryDate: this.issueDateBeforeExpiryDate,
            birthDateBeforeIssueDate: this.birthDateBeforeIssueDate,
            birthDateBeforeExpiryDate: this.birthDateBeforeExpiryDate,
        };
    }
}
/**
Report of the suspicious data field verification.
*/
export class FieldSuspiciousDataVerificationReport {
    /** @param source {@displayType `DeepPartial<FieldSuspiciousDataVerificationReport>`} */
    constructor(source = {}) {
        if (source.fieldFullName !== undefined) {
            this.fieldFullName = source.fieldFullName;
        }
        else {
            throw new Error('fieldFullName must be present in constructor argument');
        }
        if (source.isSuspicious !== undefined) {
            this.isSuspicious = source.isSuspicious;
        }
        else {
            throw new Error('isSuspicious must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            fieldFullName: this.fieldFullName,
            isSuspicious: this.isSuspicious,
        };
    }
}
/**
Report of the suspicious data document verification.
*/
export class SuspiciousDataVerificationReport {
    /** @param source {@displayType `DeepPartial<SuspiciousDataVerificationReport>`} */
    constructor(source = {}) {
        if (source.overallSuspiciousData !== undefined) {
            this.overallSuspiciousData = source.overallSuspiciousData;
        }
        else {
            throw new Error('overallSuspiciousData must be present in constructor argument');
        }
        if (source.fieldDetails !== undefined) {
            this.fieldDetails = source.fieldDetails.map((it) => {
                return new FieldSuspiciousDataVerificationReport(it);
            });
        }
        else {
            throw new Error('fieldDetails must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            overallSuspiciousData: this.overallSuspiciousData,
            fieldDetails: this.fieldDetails.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/**
Report which shows whether the data in the field that can be validated is valid.
*/
export class FieldInvalidDataVerificationReport {
    /** @param source {@displayType `DeepPartial<FieldInvalidDataVerificationReport>`} */
    constructor(source = {}) {
        if (source.fieldFullName !== undefined) {
            this.fieldFullName = source.fieldFullName;
        }
        else {
            throw new Error('fieldFullName must be present in constructor argument');
        }
        if (source.isInvalid !== undefined) {
            this.isInvalid = source.isInvalid;
        }
        else {
            throw new Error('isInvalid must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            fieldFullName: this.fieldFullName,
            isInvalid: this.isInvalid,
        };
    }
}
/**
Report of the field validation verification.
*/
export class InvalidDataVerificationReport {
    /** @param source {@displayType `DeepPartial<InvalidDataVerificationReport>`} */
    constructor(source = {}) {
        if (source.overallIsInvalid !== undefined) {
            this.overallIsInvalid = source.overallIsInvalid;
        }
        else {
            throw new Error('overallIsInvalid must be present in constructor argument');
        }
        if (source.fieldDetails !== undefined) {
            this.fieldDetails = source.fieldDetails.map((it) => {
                return new FieldInvalidDataVerificationReport(it);
            });
        }
        else {
            throw new Error('fieldDetails must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            overallIsInvalid: this.overallIsInvalid,
            fieldDetails: this.fieldDetails.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/** @hidden */
export const DocumentVerificationStatusValues = [
    'OK',
    'OK_WITH_WARNINGS',
    'INVALID',
];
/**
Report of the document verification.
*/
export class DocumentVerificationReport {
    /** @param source {@displayType `DeepPartial<DocumentVerificationReport>`} */
    constructor(source = {}) {
        if (source.overallVerificationStatus !== undefined) {
            this.overallVerificationStatus = source.overallVerificationStatus;
        }
        else {
            throw new Error('overallVerificationStatus must be present in constructor argument');
        }
        if (source.consistencyVerificationReport !== undefined) {
            this.consistencyVerificationReport = new ConsistencyVerificationReport(source.consistencyVerificationReport);
        }
        else {
            throw new Error('consistencyVerificationReport must be present in constructor argument');
        }
        if (source.semanticsVerificationReport !== undefined) {
            this.semanticsVerificationReport = new SemanticsVerificationReport(source.semanticsVerificationReport);
        }
        else {
            throw new Error('semanticsVerificationReport must be present in constructor argument');
        }
        if (source.suspiciousDataVerificationReport !== undefined) {
            this.suspiciousDataVerificationReport = new SuspiciousDataVerificationReport(source.suspiciousDataVerificationReport);
        }
        else {
            throw new Error('suspiciousDataVerificationReport must be present in constructor argument');
        }
        if (source.invalidDataVerificationReport !== undefined) {
            this.invalidDataVerificationReport = new InvalidDataVerificationReport(source.invalidDataVerificationReport);
        }
        else {
            throw new Error('invalidDataVerificationReport must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            overallVerificationStatus: this.overallVerificationStatus,
            consistencyVerificationReport: this.consistencyVerificationReport.serialize(config),
            semanticsVerificationReport: this.semanticsVerificationReport.serialize(config),
            suspiciousDataVerificationReport: this.suspiciousDataVerificationReport.serialize(config),
            invalidDataVerificationReport: this.invalidDataVerificationReport.serialize(config),
        };
    }
}
//# sourceMappingURL=DocumentDataExtractorTypes.js.map